import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useMobileMenu } from '../../contexts/MobileMenuContext';
import './MobilePageBar.css';

/**
 * Global mobile-only top bar — hamburger on the left, avatar + Logout on
 * the right, page title rendered between them when provided. Mounted once
 * at App level so it's available on every authenticated page; per-page
 * code only needs to set the title via context.
 *
 * Reason it lives here and not in <Navbar/>: when the app is installed as
 * a PWA, the iOS status bar (time/wifi/battery) overlays the very top of
 * the screen. Anchoring controls in the page content area (with
 * env(safe-area-inset-top) padding) puts them firmly inside the tappable
 * region. The desktop navbar is hidden via media query on the same break
 * so this is the *only* nav surface on mobile.
 */
const MobilePageBar: React.FC = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const { open, toggle } = useMobileMenu();

  if (!isAuthenticated) return null;

  return (
    <div className="mobile-page-bar">
      <button
        className={`mobile-page-bar__hamburger ${open ? 'is-open' : ''}`}
        onClick={toggle}
        aria-label="Open menu"
        aria-expanded={open}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div className="mobile-page-bar__spacer" />
      <div className="mobile-page-bar__user">
        {user?.profile_picture_url && (
          <img
            src={user.profile_picture_url}
            alt={`${user.first_name} ${user.last_name}`}
            className="mobile-page-bar__avatar"
          />
        )}
        <button onClick={logout} className="mobile-page-bar__logout">
          Logout
        </button>
      </div>
    </div>
  );
};

export default MobilePageBar;
